export const MEDMATE_TELEHEALTH_LOCATION_ID = 3287;
export const TELEHEALTH_FOLLOW_UP_LOCATION_ID = 4526;
export const CONFORMANCE_ID = 'Medmate_Connect_MA|3.0.4';
export const PAPER_SCRIPT = 'Paper Script';
export const UPLOADED_VIA_QR_CODE = 'Uploaded via QR Code';